import Flickity from 'flickity';

jQuery(function ($) {
  const sliders = document.querySelectorAll('.flickty_slider');
  if(sliders.length){
    sliders.forEach(el => {

      const slider = new Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const homepageQuantumHero = document.getElementById('homepage-hero-row');
  if (homepageQuantumHero) {
    setTimeout(() => {
      homepageQuantumHero.classList.add('traina-animate');
    }, 1000);
  }
});